// extracted by mini-css-extract-plugin
export default {"container":"CellError_container__rfdxT","icon":"CellError_icon__5fBQe","message":"CellError_message__ZTguD"};